import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=0a0fa7cc&scoped=true"
import script from "./baseTable.vue?vue&type=script&lang=js"
export * from "./baseTable.vue?vue&type=script&lang=js"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=0a0fa7cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fa7cc",
  null
  
)

export default component.exports